// Chakra Imports
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Flex,
  Link,
  useColorModeValue,
  Text
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import AdminNavbarLinks from "./AdminNavbarLinks";

export default function AdminNavbar(props) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", changeNavbar);

    return () => {
      window.removeEventListener("scroll", changeNavbar);
    }
  })

  const {
    variant,
    children,
    fixed,
    secondary,
    brandText,
    onOpen,
    ...rest
  } = props;

  // Here are all the props that may change depending on navbar's type or state.(secondary, variant, scrolled)
  let mainText = (fixed && scrolled) ? useColorModeValue("gray.700", "gray.200") : useColorModeValue("white", "gray.200");
  let secondaryText = (fixed && scrolled) ? useColorModeValue("gray.700", "gray.200") : useColorModeValue("white", "gray.200");
  // Always keep navbar fixed for consistent positioning
  let navbarPosition = "fixed";
  let navbarFilter = "none";
  let navbarBackdrop = "none";
  let navbarShadow = "none";
  let navbarBg = "none";
  let navbarBorder = "transparent";
  let secondaryMargin = "0px";
  let paddingX = "15px";
  if (props.fixed === true)
    if (scrolled === true) {
      // Keep navbar fixed, only change visual properties
      navbarPosition = "fixed";
      navbarShadow = useColorModeValue(
        "0px 7px 23px rgba(0, 0, 0, 0.05)",
        "none"
      );
      navbarBg = useColorModeValue(
        "linear-gradient(112.83deg, rgba(255, 255, 255, 0.82) 0%, rgba(255, 255, 255, 0.8) 110.84%)",
        "linear-gradient(112.83deg, rgba(255, 255, 255, 0.21) 0%, rgba(255, 255, 255, 0) 110.84%)"
      );
      navbarBorder = useColorModeValue("#FFFFFF", "rgba(255, 255, 255, 0.31)");
      navbarFilter = useColorModeValue(
        "none",
        "drop-shadow(0px 7px 23px rgba(0, 0, 0, 0.05))"
      );
    }
  if (props.secondary) {
    navbarBackdrop = "none";
    // Keep navbar fixed even for secondary pages
    navbarPosition = "fixed";
    mainText = "white";
    secondaryText = "white";
    secondaryMargin = "22px";
    paddingX = "30px";
  }
  const changeNavbar = () => {
    if (window.scrollY > 1) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };
  
  return (
    <Flex
      position={navbarPosition}
      top="18px"
      right={{ base: "30px", xl: "306px" }}
      left="30px"
      zIndex="1000"
      boxShadow="0 8px 32px rgba(0, 0, 0, 0.1)"
      bg="rgba(255, 255, 255, 0.1)"
      borderColor="rgba(255, 255, 255, 0.3)"
      filter="none"
      backdropFilter="blur(20px)"
      borderWidth="1px"
      borderStyle="solid"
      transitionDelay="0s, 0s, 0s, 0s"
      transitionDuration=" 0.25s, 0.25s, 0.25s, 0s"
      transition-property="box-shadow, background-color, filter, border"
      transitionTimingFunction="linear, linear, linear, linear"
      alignItems={{ xl: "center" }}
      borderRadius="16px"
      display="flex"
      minH="75px"
      justifyContent={{ xl: "center" }}
      lineHeight="25.6px"
      mx="auto"
      mt={secondaryMargin}
      px={paddingX}
      direction="rtl"
      className="navbar-header">
      <Box
        ms="auto"
        me="auto"
        w="100%"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        className="navbar-container">
        <Box>
          <Text
            color={mainText}
            fontWeight="700"
            fontSize="20px"
            lineHeight="100%"
            textAlign="right">
            {brandText}
          </Text>
          {secondary ? (
            <Text
              color={secondaryText}
              fontSize="14px"
              fontWeight="400"
              lineHeight="100%"
              textAlign="right">
              {secondary}
            </Text>
          ) : null}
        </Box>
        <Box>
          <AdminNavbarLinks
            onOpen={onOpen}
            logoText={props.logoText}
            brandText={props.brandText}
            secondary={props.secondary}
            fixed={props.fixed}
            {...rest}
          />
        </Box>
      </Box>
    </Flex>
  );
}